/** timezones supported */
export const ZONE_NAMES = [
  "America/Phoenix",
  "America/North_Dakota/Center",
  "America/North_Dakota/Beulah",
  "America/Indiana/Marengo",
  "America/New_York",
  "America/Kentucky/Monticello",
  "America/Boise",
  "America/Chicago",
  "America/Nome",
  "America/Indiana/Vincennes",
  "America/Yakutat",
  "America/Sitka",
  "America/Indiana/Indianapolis",
  "America/Indiana/Winamac",
  "America/Indiana/Knox",
  "America/Indiana/Tell_City",
  "Pacific/Honolulu",
  "America/Puerto_Rico",
  "America/Anchorage",
  "America/Los_Angeles",
  "America/Indiana/Vevay",
  "America/Metlakatla",
  "America/North_Dakota/New_Salem",
  "America/Adak",
  "America/Juneau",
  "America/Denver",
  "America/Indiana/Petersburg",
  "America/Menominee",
  "Israel",
].sort((a, b) => a.localeCompare(b));
